import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import type { DsIcon } from '@bonniernews/dn-design-system-web/types-lib/ds-icon.d.ts'

import { IconUse } from '@bonniernews/dn-design-system-web/components/icon-sprite/icon-sprite.tsx'

export interface PictogramProps {
  variant?: 'brand' | 'business' | 'game'
  iconName: DsIcon
  size?: 'large' | 'small'
  classNames?: string
  attributes?: object
  forcePx?: boolean
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/Pictogram](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/pictogram)
 * - Storybook: [Pictogram](https://designsystem.dn.se/?path=/docs/article-Pictogram--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/pictogram/pictogram.scss'`
 */
export const Pictogram = ({
  variant = 'brand',
  iconName,
  size = 'small',
  classNames,
  attributes,
  forcePx,
}: PictogramProps) => {
  const componentClassName = 'ds-pictogram'

  const classes = formatClassString([
    componentClassName,
    `${componentClassName}--${variant}`,
    `${componentClassName}--${size}`,
    forcePx && 'ds-force-px',
    classNames,
  ])

  return (
    <div className={classes} {...attributes} aria-hidden='true'>
      <IconUse iconName={iconName} />
    </div>
  )
}
